import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import SearchResults from "../screens"
import {SearchHeader} from '../components/Header'

export default function Search() {
    const [fixed, setFixed] = React.useState('')
    React.useLayoutEffect(()=>{
        const getY = ()=>{
          return window.pageXOffset !== undefined ? window.pageYOffset : (document.compatMode || "") === "CSS1Compat" ? document.documentElement.scrollTop : document.body.scrollTop;
        }
        const handleScroll = () => {
            const y = getY();
            if (y < 120) {
                setFixed("")
            } else if (y >= 120 && y < 145) {
                setFixed("fixed")
            } else {
                setFixed("fixed show")
            }
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])
    return (
        <Router >
            <SearchHeader fixed={fixed}/>
            <Switch>
                <Route children={<SearchResults />} />
            </Switch>
        </Router>
    );
}
